"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transferWidget = exports.unpublishWidget = exports.getTemplateList = exports.createWidget = exports.getWidgetsInfoByNodeId = exports.getRecentInstalledWidgets = exports.copyWidgetsToDashboard = exports.installWidget = exports.getWidgetsByNodeId = exports.getWidgetCenterList = exports.readInstallationWidgets = void 0;
const axios_1 = __importDefault(require("axios"));
const Url = __importStar(require("./url.widget"));
const qs_1 = __importDefault(require("qs"));
const urlcat_1 = __importDefault(require("urlcat"));
const store_1 = require("../../../exports/store");
// const baseURL = '/nest/v1';
const readInstallationWidgets = (widgetIds, linkId) => {
    return axios_1.default.get(Url.INSTALLATION_WIDGETS, {
        params: {
            widgetIds: widgetIds.join(','),
            linkId,
        },
        // serialize arguement revisions: [1,2,3] to normal GET params revisions=1&revisions=2&revisions=3
        paramsSerializer: params => {
            return qs_1.default.stringify(params, { arrayFormat: 'repeat' });
        },
    });
};
exports.readInstallationWidgets = readInstallationWidgets;
/**
 * get widget list from widget center
 */
const getWidgetCenterList = (type, filter = true) => {
    return axios_1.default.post(Url.WIDGET_CENTER_LIST, { type, filter });
};
exports.getWidgetCenterList = getWidgetCenterList;
const getWidgetsByNodeId = (nodeId) => {
    return axios_1.default.get((0, urlcat_1.default)(Url.GET_NODE_WIDGETS, { nodeId }));
};
exports.getWidgetsByNodeId = getWidgetsByNodeId;
const installWidget = (nodeId, packageId, name) => {
    return axios_1.default.post(Url.INSTALL_WIDGET, {
        nodeId: nodeId,
        widgetPackageId: packageId,
        name
    });
};
exports.installWidget = installWidget;
/**
 * in widget panel, send widget to dashboard or import widget in dashboard
 *
 * @param dashboardId
 * @param widgetId
 */
const copyWidgetsToDashboard = (dashboardId, widgetIds) => {
    return axios_1.default.post(Url.COPY_WIDGET, {
        dashboardId,
        widgetIds: widgetIds,
    });
};
exports.copyWidgetsToDashboard = copyWidgetsToDashboard;
const getRecentInstalledWidgets = (spaceId) => {
    return axios_1.default.get((0, urlcat_1.default)(Url.RECENT_INSTALL_WIDGET, { spaceId }));
};
exports.getRecentInstalledWidgets = getRecentInstalledWidgets;
const getWidgetsInfoByNodeId = (nodeId) => {
    return axios_1.default.get((0, urlcat_1.default)(Url.GET_NODE_WIDGETS_PREVIOUS, { nodeId }));
};
exports.getWidgetsInfoByNodeId = getWidgetsInfoByNodeId;
/**
 * create widget
 * @param name
 * @param spaceId
 * @param packageType
 * @param releaseType
 * @returns
 */
const createWidget = (name, spaceId, packageType = store_1.WidgetPackageType.Custom, releaseType = store_1.WidgetReleaseType.Space) => {
    return axios_1.default.post(Url.CREATE_WIDGET, { name, spaceId, packageType, releaseType });
};
exports.createWidget = createWidget;
const getTemplateList = () => {
    return axios_1.default.get(Url.GET_TEMPLATE_LIST);
};
exports.getTemplateList = getTemplateList;
/**
 * unpublish widget
 * @param widgetPackageId
 * @returns
 */
const unpublishWidget = (widgetPackageId) => {
    return axios_1.default.post(Url.UNPUBLISH_WIDGET, { packageId: widgetPackageId });
};
exports.unpublishWidget = unpublishWidget;
/**
 * transfer widget to others
 *
 * @param packageId
 * @param transferMemberId
 * @returns
 */
const transferWidget = (packageId, transferMemberId) => {
    return axios_1.default.post(Url.TRANSFER_OWNER, { packageId, transferMemberId });
};
exports.transferWidget = transferWidget;
//# sourceMappingURL=widget_api.js.map